import { BreakpointState } from "@angular/cdk/layout";
import { ChangeDetectorRef, Component, OnDestroy, OnInit } from "@angular/core";
import { Subscription } from "rxjs";

import { Context } from "@hermes/app-core";
import { BreakpointService } from "@hermes/utils-generic/services/user-interface";

/**
 * This component implements template for product page, with two columns, right one is sticked.
 * Do not use it to put some business logic common for product page, its manage only style.
 *
 * Usage:
 * ```
 * <h-two-columns>
 *
 *  <div rightColumn>
 *      <div class="my-right-content">content</div>
 *  </div>
 *
 *  <div leftColumn>
 *      <div class="my-left-content">content</div>
 *  </div>
 *
 * </h-two-columns>
 * ```
 */
@Component({
    selector: "h-two-columns",
    templateUrl: "./two-columns.component.html",
    styleUrls: ["./two-columns.component.scss"],
})
export class TwoColumnsComponent implements OnInit, OnDestroy {
    public isMobile: boolean = false;

    public subscription = new Subscription();

    constructor(
        private context: Context,
        private breakpointService: BreakpointService,
        private changeDetector: ChangeDetectorRef,
    ) {}

    public ngOnInit(): void {
        if (this.context.isInBrowserMode()) {
            this.subscription.add(
                this.breakpointService
                    .mediumBreakpointObserver()
                    .subscribe((value: BreakpointState) => {
                        this.isMobile = !value.matches;
                        this.changeDetector.detectChanges();
                    }),
            );
        }
    }

    public ngOnDestroy(): void {
        this.subscription.unsubscribe();
    }
}
